//Built-In
import React, {Fragment} from 'react';

//External
//Internal
export default class FooterComponent extends React.Component{
    constructor(props) {
        super(props);
    }

    render(){
        let component = this.props.component;
        let bodyText = component['text'];
        return (
            <Fragment>
                <div className={'d-grid'}>
                    <label className={'group-header-lbl'}>Footer</label>
                    <div className={'footer-content'}>
                        {bodyText}
                    </div>
                </div>
            </Fragment>
        )
    }
}
